/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  linked_months: [],
  linked_operators: [],
  linked_departures: [],
  linked_recommended: [],
  linked_countries: [],
  linked_country_list: [],
};
const name = 'linked';

// reducer + actions
const linked = createSlice({
  name,
  initialState,
  reducers: {},
});

export default linked.reducer;
